import { FormGroup } from '@angular/forms';

import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';

import { MentionInsightTypes } from '../enums/mention-insight-types.enum';
import { InsightModel } from './insight.model';
import { AiAnalysisTypes } from '../enums/ai-analysis-types.enum';


export interface PromptModel {
    type: MentionInsightTypes | AiAnalysisTypes;
    responseType?: PromptResponseTypesEnum;
    mentionId?: string;
    insightSaved?: boolean;
    isGenerating$?: BehaviorSubject<boolean>;
    generating?: boolean;
    insightText?: string;
    insightModel?: InsightModel;
    aiResponse?: string;
    keywords?: string[];
    oldKeywords?: string[];
    formGroup?: FormGroup;
    keywordValueChangeSubscription?: Subscription;
    noContentGenerated?: boolean;
    apiCall?: Subscription;
    destroyApiCall$?: Subject<void>;
    context?: string;
    brand?: string;
    name?: string;
    customInsightId?: number;
    promptText?: string;
};

export enum PromptResponseTypesEnum {
    PLAIN_TEXT = 'PLAIN_TEXT',
    INTERACTIVE_LIST = 'INTERACTIVE_LIST',
    CHARACTERIZATION = 'CHARACTERIZATION'
}
